import React from 'react';
import { Criterion, CriterionListItem, Field, FieldType } from '../queries';
import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from '@app/theme';
const useStyles = createUseStyles((theme: Theme) => ({
  content: {
    ...theme.fonts.body,
  },
}));

interface Props {
  criterion: Criterion;
  field?: Field;
}

const criterionChoiceText = (field?: Field) => (value: CriterionListItem) => {
  if (value && typeof value === 'object') {
    if ('location' in value) {
      return `${value.name} ${value.radius} km`;
    } else {
      if (!value.max) {
        return `"More than ${value.min}"`;
      }
      if (!value.min) {
        return `"Less than ${value.max}"`;
      }
      return `"Between ${value.min} and ${value.max}"`;
    }
  }

  if (
    field &&
    (field.type === FieldType.SINGLE_CHOICE ||
      field.type === FieldType.MULTIPLE_CHOICE) &&
    field.properties.choices
  ) {
    const choice = field.properties.choices.find(
      ({ ref }) => String(ref) === String(value),
    );
    if (!choice) {
      return value;
    }
    return choice.label;
  }
  return value;
};

export const AdminCriterionDetails = ({ criterion, field }: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });
  return (
    <div className={classes.content}>
      {criterion.allowList && (
        <div>
          Must be one of{' '}
          {criterion.allowList.map(criterionChoiceText(field)).join(', ')}
        </div>
      )}
      {criterion.denyList && !!criterion.denyList.length && (
        <div>
          Must not be one of{' '}
          {criterion.denyList.map(criterionChoiceText(field)).join(', ')}
        </div>
      )}
      {criterion.automaticlyAcceptedList && (
        <div>
          Automaticly accept :{' '}
          {criterion.automaticlyAcceptedList
            .map(criterionChoiceText(field))
            .join(', ')}
        </div>
      )}
    </div>
  );
};
